import React, { Component } from 'react';
import { Icon } from 'antd';

class StepTwo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            wagers: {}
        };

    }
    async componentWillMount() {
        console.log(this.state.loading);
        if (this.props.makerChoice === 1) {
            this.setState({ wagers: this.props.teamOneWagers })
            setTimeout(() => {
                console.log("WAGERS: " + JSON.stringify(Array.from(this.state.wagers)));
                this.setState({ loading: false });
                console.log(this.state.loading);
                console.log("maker choice: " + this.props.makerChoice)
            }, 1000)

        }
        else if (this.props.makerChoice === 2) {
            this.setState({ wagers: this.props.teamTwoWagers });
            setTimeout(() => {
                console.log("WAGERS: " + JSON.stringify(Array.from(this.state.wagers)));
                this.setState({ loading: false });
                console.log(this.state.loading);
                console.log("maker choice: " + this.props.makerChoice)
            }, 1000)
        }
        else {
            this.setState({ wagers: null });
            setTimeout(() => {
                console.log("WAGERS: " + JSON.stringify(Array.from(this.state.wagers)));
                this.setState({ loading: false });
                console.log(this.state.loading);
                console.log("maker choice: " + this.props.makerChoice)
            }, 1000)
        }


    }

    renderWager(wager) {
        return (
            <div style={{ background: '#353b46', padding: '10px' }} key={wager._id}>
                <p>Maker: {wager.maker}</p>
                <p>Taker: {wager.taker}</p>
                <p>Value: {wager.value}</p>
                <p>Odds: {wager.odds}</p>
                <button className="custom-btn-primary">Take Bet</button>
            </div>
        );
    }

    renderWagers() {
        let wagerList = [];

        for (let wager of this.state.wagers.values()) {
            console.log(wager);
            wagerList.push(this.renderWager(wager));
        }
        return wagerList;
    }

    render() {


        let content = ""


        if (this.state.loading) {
            content = <div><Icon type="loading" /> Loading....</div>
        }
        if (!this.state.loading) {
            <h3>{this.state.wagers.values().length} Available Bets</h3>

            content = <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridGap: '15px' }}>
                {this.renderWagers()}
            </div>
        }

        return (
            <div>
                <h1>Make or Take a Bet</h1>
                {content}
            </div>
        );
    }
}

export default StepTwo;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/betSteps/StepTwo.js